import axios from "axios";
import { useEffect } from "react";
import { useState } from "react";
import ModalUmum from "../../modal/modalUmum/ModalUmum";
import Loading from "../../components/loading/Loading";
import { useNavigate } from "react-router-dom";

function Adduser() {
  const navigate = useNavigate();
  const [modalShow, setModalShow] = useState(false);
  const [title, setTitle] = useState();
  const [loading, setLoading] = useState();
  const [verifyEmail, setVerifyEmail] = useState();
  const sizeImage = 1000000;

  const [add, setAdd] = useState({
    // qr: "",
    name: "",
    phone: "",
    email: "",
    birthday: false,
    since: false,
    expired: false,
    active: false,
    address: "",
    password: "",
    gender: "male",
    point: 0,
  });

  const [image, setImage] = useState(false);

  const addUserMobile = async () => {
    const data = new FormData();
    // data.append("qr", add.qr);
    data.append("name", add.name);
    data.append("phone", add.phone);
    data.append("email", add.email);
    data.append("birthday", add.birthday);
    data.append("since", add.since);
    data.append("expired", add.expired);
    data.append("active", add.active);
    data.append("password", add.password);
    data.append("address", add.address);
    data.append("gender", add.gender);
    data.append("point", add.point);
    data.append("image", image);
    if (image.size > sizeImage) {
      setTitle("Image size is too Big, Maximum size 1MB");
      setModalShow(true);
    } else if (
      add.name != "" &&
      add.email != "" &&
      add.phone !== "" &&
      add.address != "" &&
      add.birthday != false &&
      image != false &&
      add.password != ""
    ) {
      setLoading(true);
      const result = await axios.post("https://mobile.amospa.com/users", data);
      setLoading(false);
      if (result.data?.msg === "Email already registered") {
        setVerifyEmail(true);
      } else {
        setTitle("Success Add New User");
        setModalShow(true);
      }
    } else {
      setTitle("fill in all forms");
      setModalShow(true);
    }
  };

  //Handle Next
  const handleNext = async () => {
    setModalShow(false);
    navigate("/homepage/users-mobile/");
  };

  useEffect(() => {}, []);

  return (
    <div>
      {loading ? (
        <Loading />
      ) : (
        <div>
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="wrapper-add-user">
                  <div className="wrapper-edit-image">
                    <div className="header-edit-image">
                      <h5 className="m-0">Create New User</h5>
                    </div>
                    <div className="data-user">
                      <div className="wrapper-data">
                        <label>
                          Name <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          name="name"
                          onChange={(e) =>
                            setAdd({ ...add, name: e.target.value })
                          }
                        />
                      </div>

                      <div className="wrapper-data">
                        <label>
                          Email Address<span className="text-danger">*</span>
                        </label>
                        {verifyEmail && (
                          <div className="alert-email text-danger">
                            Email sudah terdaftar, gunakan Email lain. . .
                          </div>
                        )}
                        <input
                          type="text"
                          name="email"
                          onChange={(e) =>
                            setAdd({ ...add, email: e.target.value })
                          }
                        />
                      </div>
                      <div className="wrapper-data">
                        <label>
                          Phone <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          name="phone"
                          onChange={(e) =>
                            setAdd({ ...add, phone: e.target.value })
                          }
                        />
                      </div>
                      <div className="wrapper-data">
                        <label>
                          Home Address <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          name="email"
                          onChange={(e) =>
                            setAdd({ ...add, address: e.target.value })
                          }
                        />
                      </div>
                      <div className="wrapper-data">
                        <label>
                          Gender <span className="text-danger">*</span>
                        </label>
                        <select
                          name="gender"
                          onChange={(e) =>
                            setAdd({ ...add, gender: e.target.value })
                          }
                        >
                          <option value="male">Male</option>
                          <option value="female">Female</option>
                        </select>
                      </div>
                      <div className="wrapper-data">
                        <label>
                          Date of Birth <span className="text-danger">*</span>
                        </label>
                        <input
                          type="date"
                          name="birthday"
                          onChange={(e) =>
                            setAdd({ ...add, birthday: e.target.value })
                          }
                        />
                      </div>

                      <div className="wrapper-data">
                        <label>
                          Image (Max 1MB)<span className="text-danger">*</span>{" "}
                          <span className="text-danger ms-2">
                            {image && image.size > sizeImage
                              ? "Image size is too Big"
                              : ""}
                          </span>
                        </label>
                        <input
                          type="file"
                          onChange={(e) => setImage(e.target.files[0])}
                        />
                      </div>
                      <div className="wrapper-data">
                        <label>
                          Password <span className="text-danger">*</span>
                        </label>
                        <input
                          type="password"
                          name="phone"
                          onChange={(e) =>
                            setAdd({ ...add, password: e.target.value })
                          }
                        />
                      </div>
                      <button onClick={() => addUserMobile()}>
                        Create User Mobile
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <ModalUmum
        show={modalShow}
        onHide={() => setModalShow(false)}
        title={title}
        nextButton={
          title !== "Isi Semua Form" &&
          title !== "Image size is too Big, Maximum size 1MB"
            ? handleNext
            : () => setModalShow(false)
        }
      />
    </div>
  );
}

export default Adduser;
